import { useCallback, useMemo, useState } from "react";
import { IDropdownOption } from "@fluentui/react/lib/Dropdown";

import { getCurrencyPosition } from "Utils/Number";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { IEditFieldProps } from "../IEditFieldProps";
import { IUseEditMoney } from "./IUseEditMoney";

export function useEditMoney(props: IEditFieldProps): IUseEditMoney {
  const {
    config, item, fieldName, currencyFieldName, fallbackFieldName, onChange, translator
  } = props;

  const currencyOptions = useMemo(
    () => config.getSupportedCurrencies().map<IDropdownOption>((currencyCode) => ({
      key: currencyCode,
      text: currencyCode
    })),
    [config]
  );

  const [selectedCurrency, setSelectedCurrency] = useState<string>(item?.[currencyFieldName]?.toString() ?? null);
  const onChangeCurrency = useCallback(
    (_, option: IDropdownOption): void => {
      const { text } = option ?? {};
      setSelectedCurrency(text);
      onChange(currencyFieldName, text);
    },
    [currencyFieldName, onChange]
  );

  const hasValue = isNotNullOrWhiteSpace(item?.[fieldName] as string);
  const hasCurrency = isNotNullOrWhiteSpace(selectedCurrency);
  const fallback = item?.[fallbackFieldName]?.toString();
  const showFallback = isNotNullOrWhiteSpace(fallback) && (!hasValue || !hasCurrency);
  const currencyPosition = useMemo(() => getCurrencyPosition(translator.getActiveLocale()), [translator]);

  return {
    currencyFieldName,
    currencyOptions,
    currencyPosition,
    fallback,
    onChangeCurrency,
    selectedCurrency,
    showFallback
  };
}
